<template>
  <div>
    <!-- <div class="secondary-dark-background"> -->
    <!-- <div v-show="false" class="dark-bg">
      <div class="dovemed-wrapper">
        <div class="row py-5">
          <div class="col-6 col-md-3">
            <h5>Quick Links</h5>
            <p class="hyper-link-blue mb-1">About</p>
            <p class="hyper-link-blue mb-1">Partnerships</p>
            <p class="hyper-link-blue mb-1">Privacy Policy</p>
            <p class="hyper-link-blue mb-1">Terms of Use</p>
            <p class="hyper-link-blue mb-1">FAQ</p>
            <p class='hyper-link mb-1'>Crisis</p>
          </div>
          <div class="col-6 col-md-3">
            <h5>Our networks</h5>
            <p class="hyper-link-blue mb-1">MyIBSCircle</p>
            <p class="hyper-link-blue mb-1">MyAutismCircle</p>
            <p class="hyper-link-blue mb-1">MyDiabetesCircle</p>
            <p class="hyper-link-blue mb-1">MyMSCircle</p>
            <p class="hyper-link-blue mb-1">MyObesityCircle</p>
            <p class="hyper-link-blue mb-1">MyDepressionCircle</p>
            <p class="hyper-link-blue mb-1">MyFibroCircle</p>
            <p class="hyper-link-blue mb-1">MyLupusCircle</p>
            <p class="hyper-link-blue mb-1">MyFoodAlergyCircle</p>
          </div>
          <div class="col-md-3 d-none d-md-block">
            <h5 class="invisible">...</h5>
            <p class="hyper-link-blue mb-1">MyIBSCircle</p>
            <p class="hyper-link-blue mb-1">MyAutismCircle</p>
            <p class="hyper-link-blue mb-1">MyDiabetesCircle</p>
            <p class="hyper-link-blue mb-1">MyMSCircle</p>
            <p class="hyper-link-blue mb-1">MyObesityCircle</p>
            <p class="hyper-link-blue mb-1">MyDepressionCircle</p>
            <p class="hyper-link-blue mb-1">MyFibroCircle</p>
            <p class="hyper-link-blue mb-1">MyLupusCircle</p>
            <p class="hyper-link-blue mb-1">MyFoodAlergyCircle</p>
          </div>
          <div class='col-3 d-none d-md-block'>
            <h5>Follow Us</h5>
              <img class="social-icon" src="../../assets/icons/social-icons/facebook.svg" alt="">
              <img class="social-icon" src="../../assets/icons/social-icons/twitter.svg" alt="">
              <img class="social-icon" src="../../assets/icons/social-icons/linkedin.svg" alt="">
              <img class="social-icon" src="../../assets/icons/social-icons/instagram.svg" alt="">
              <img class="social-icon" src="../../assets/icons/social-icons/pinterest.svg" alt="">
          </div>
        </div>
      </div>
    </div> -->
    <div
      :style="{
        background:
          $route.path.includes('searchpage') || $route.path.includes('circles') || $route.path.includes('contact-us')
            ? '#2a71d4'
            : getPrimaryColor()
      }"
    >
      <div class="dovemed-wrapper">
        <div :class="`dovemed-footer ${$route.path.includes('circles') ? '' : 'hide-in-mobile'}`">
          <div class="dovemed-footer__left">
            <div>
              <!-- <img src="../../assets/dovemed-logo.svg" alt /> -->
              <img src="../../assets/dovemed-logo-white.png" alt="footer logo" :style="{ width: '160px', height: '40px' }" />
            </div>

            <div class="disclamier-text">&copy; {{ getYear }} MyCircles. All rights reserved.</div>
          </div>
          <div class="dovemed-footer__right">
            <div @click="handleHomeClick">Home</div>
            <!-- <div @click="$router.push({ name: 'ContactUs' })">contact</div> -->
            <a :href="`${SSO_BASE_URL}/mycircles/contact-us`" target="_blank"> Contact </a>
            <a :href="`${SSO_BASE_URL}/help-center/search/faq?categoryId=f4fbe7d4-bfe2-482f-ad15-bba18b399675&subcategoryId=14e752da-7f8a-4044-9a62-c1ed942f9b8e`" target="_blank"> FAQ </a>
            <a :href="`${SSO_BASE_URL}/help-center/faq/mycircles-privacy-policy`" target="_blank"> Privacy Policy </a>
            <a :href="`${SSO_BASE_URL}/help-center/faq/mycircles-terms-of-use`" target="_blank"> Terms of Use </a>
            <a :href="`${SSO_BASE_URL}/help-center/faq/mycircles-community-guidelines`" target="_blank"> Community Guidelines </a>
            <!-- <p class='hyper-link mb-1'>Crisis</p> -->
          </div>
        </div>

        <!-- <p class='font-white mb-1 disclaimer-text'>&copy; 2018 MyCircles. All rights reserved.</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
export default {
  name: "Footer",
  computed: {
    getYear() {
      return moment().format("YYYY")
    },
    SSO_BASE_URL: () => process.env.SSO_BASE_URL,
  },
  created() {
    console.warn('FooterGeneric.vue is created');
  },
  methods: {
    handleHomeClick() {
      document.body.scrollTop = 0 // For Safari
      document.documentElement.scrollTop = 0
      this.$router.push({ name: "AllCircles" })
    },
  },
}
</script>

<style lang="scss" scoped>
.disclaimer-text {
  font-size: 12px;
}
.logo {
  width: 130px;
  align-self: center;
}
.social-icon {
  cursor: pointer;
  width: 36px;
  height: 36px;
  margin-right: 10px;
}
img {
  height: 40px;
  max-width: 161px;
  background-size: contain;
}
</style>



// WEBPACK FOOTER //
// src/components/App/FooterGeneric.vue